import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, FormGroup, Label, Input, FormFeedback } from 'reactstrap';
import SavingState from '../misc/SavingState';
import { useTranslation } from 'react-i18next';

const validate = (consumer) => {
    const validation = [];
    if (!consumer.name || consumer.name.length < 0 || consumer.name.length > 64) {
        validation.push('name');
    }
    if (!consumer.clientId || consumer.clientId.length < 0 || consumer.clientId.length > 64) {
        validation.push('clientId');
    }
    return validation;
}

const ConsumerCreateUpdate = (props) => {
    const { t } = useTranslation(['common']);
    const [consumer, setConsumer] = useState(props.consumer);
    const [save, setSave] = useState(false);
    let validation = validate(consumer);

    const updateConsumer = (e) => {
        setConsumer({ ...consumer, [e.target.name]: e.target.value })
    }

    const saveConsumer = () => {
        const valid = !validation.length;
        if (valid) {
            props.update(consumer);
        }
    }

    return (
        <Modal isOpen={props.isOpen} toggle={props.toggle}>
            <ModalHeader toggle={props.toggle}>
                {props.crud === 'CREATE' && t('apiConsumers.createConsumer', { ns: 'common' })}
                {props.crud === 'UPDATE' && t('apiConsumers.editConsumer', { ns: 'common' })}
            </ModalHeader>
            <ModalBody>
                <FormGroup>
                    <Label for="name">{t('apiConsumers.apiConsumersListHeaderes.name', { ns: 'common' })}</Label>
                    <Input type="text" name="name" placeholder={t('apiConsumers.apiConsumersListHeaderes.name', { ns: 'common' })} value={consumer.name || ''}
                        onChange={updateConsumer} disabled={props.crud === 'REMOVE'} autoComplete="off" invalid={save && validation.indexOf('name') !== -1} />
                    <FormFeedback>{t('apiConsumers.feedback.nameRequired', { ns: 'common' })}</FormFeedback>
                </FormGroup>
                <FormGroup>
                    <Label for="clientId">{t('apiConsumers.apiConsumersListHeaderes.clientId', { ns: 'common' })}</Label>
                    <Input type="text" name="clientId" placeholder={t('apiConsumers.apiConsumersListHeaderes.clientId', { ns: 'common' })} value={consumer.clientId || ''}
                        onChange={updateConsumer} disabled={props.crud === 'REMOVE'} autoComplete="off" invalid={save && validation.indexOf('clientId') !== -1} />
                    <FormFeedback>{t('apiConsumers.feedback.clientIdRequired', { ns: 'common' })}</FormFeedback>
                </FormGroup>
            </ModalBody>
            <ModalFooter>
                <Button onClick={props.toggle}>{t('close', { ns: 'common' })}</Button>
                <Button className="btn-primary" onClick={() => (saveConsumer(), setSave(true))}>{t('save', { ns: 'common' })}</Button>
                <SavingState status={props.savingState} />

                {props.error && <>
                    <p>{t('apiConsumers.errorMessages', { ns: 'common' })}</p>
                    <ul>
                        {props.error?.response?.data?.errors?.Name?.map((x, i) => <li key={i}>{x}</li>)}
                        {props.error?.response?.status === 409 ? <li>{t('apiConsumers.clientIdAlreadyExists', { ns: 'common' })}</li> : null}
                    </ul>
                </>}
            </ModalFooter>
        </Modal>
    )
}

export default ConsumerCreateUpdate;
